"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOnPropChangedAnalytic = void 0;
var react_1 = __importStar(require("react"));
var use_analytics_1 = require("../hooks/use-analytics");
var wrapDisplayName_1 = require("../wrapDisplayName");
var defaultValueFilter = function () { return true; };
function withOnPropChangedAnalytic(_a) {
    var propName = _a.propName, analyticName = _a.analyticName, _b = _a.valueFilter, valueFilter = _b === void 0 ? defaultValueFilter : _b, _c = _a.includeFirstValue, includeFirstValue = _c === void 0 ? false : _c, extendAnalytics = _a.extendAnalytics;
    return function (BaseComponent) {
        var EnhancedComponent = function (props) {
            var analytics = use_analytics_1.useAnalytics();
            var value = props[propName];
            var prevValue = react_1.useRef(value);
            react_1.useEffect(function () {
                var isFirstValue = prevValue.current === value;
                if (isFirstValue && !includeFirstValue) {
                    return;
                }
                if (valueFilter(isFirstValue ? undefined : prevValue.current, value)) {
                    var dispatcher = analytics.dispatcher;
                    if (extendAnalytics) {
                        dispatcher = dispatcher.extend(extendAnalytics(props));
                    }
                    dispatcher.dispatch(analyticName);
                }
                prevValue.current = value;
            }, [value]);
            return react_1.default.createElement(BaseComponent, __assign({}, props));
        };
        EnhancedComponent.displayName = wrapDisplayName_1.wrapDisplayName(BaseComponent, 'withOnPropChangedAnalytic');
        return EnhancedComponent;
    };
}
exports.withOnPropChangedAnalytic = withOnPropChangedAnalytic;
